export default "__VITE_ASSET__9488e757__"